<template>
  <ams-table
    :heading="heading"
    :ams_api_path="ams_api_path"
    :ams_type="ams_type"
    :ams_fields="ams_fields"
    :filtering="filtering"
    :refresh="refresh"
    :refreshed="doRefresh"
    :reroute_name="reroute_name"
    :ams_template="ams_template"
  />
</template>

<script>
import AmsTable from './AmsTable.vue'

export default {
  components: {
    AmsTable
  },
  props: {
    filtering: {
      Type: Object
    },
    refresh: {
      Type: Boolean
    },
    ams_template: {
      Type: Object
    }
  },
  data() {
    return {
      heading: "Interests",
      ams_type: 'interests',
      ams_api_path: 'api/admin/v1',
      reroute_name: 'InterestCreateScreen',
      ams_fields: [
        {
          key: 'attributes.ancestry',
          label: 'Classification',
          sortable: false,
          filterable: true,
          class: 'text-right',
          sortDirection: 'asc',
          // A column that needs custom formatting,
          formatter: 'classification',
        },
       { 
          key: 'attributes.name',
          label: 'Interest Name',
          sortable: true,
          filterable: true,
          class: 'text-left',
          sortDirection: 'asc' 
        },
        { 
          key: 'attributes.aliases',
          label: 'Interest Aliases',
          sortable: false,
          filterable: false,
          class: 'text-left',
          sortDirection: 'asc' 
        }
      ],
    }
  },
  methods: {
    doRefresh() {
      this.emit('refreshed', true)
    }
  }
}
</script>